import { Star } from "lucide-react"
import Input from "@/components/atoms/Input/input"
import { useState } from "react"

interface RatingFieldProps {
  rating: number
  setRating: (rating: number) => void
}

export function RatingField({ rating, setRating }: RatingFieldProps) {
  const [hover, setHover] = useState(0)

  return (
    <div className="p-1">
      <fieldset className="flex items-center justify-center gap-1">
        <legend className="sr-only">Choose a rating</legend>
        {Array.from({ length: 5 }).map((_, i) => (
          <label key={i} className="relative cursor-pointer">
            <Input
              type="radio"
              value={i + 1}
              onChange={() => setRating(i + 1)}
              onMouseEnter={() => setHover(i + 1)}
              onMouseLeave={() => setHover(0)}
              className="hidden"
            />
            <Star className={(hover || rating) > i ? "fill-yellow-400" : "text-gray-300"} />
          </label>
        ))}
      </fieldset>
    </div>
  )
}
